import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  popup: function popup(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      min-width: 18px;\n      border-radius: ", ";\n      border: ", " ", ";\n      display: flex;\n    "])), t.popupBorderRadius, t.popupBorder, t.popupBorderColor);
  },
  popupIgnoreHover: function popupIgnoreHover() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      pointer-events: none;\n    "])));
  },
  content: function content(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      overflow: hidden;\n      border-radius: ", ";\n      flex-shrink: 0;\n      line-height: normal;\n    "])), t.popupBorderRadius);
  },
  contentInner: function contentInner(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      background: ", ";\n    "])), t.popupTextColor, t.popupBackground);
  },
  shadow: function shadow(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      filter: ", ";\n      -webkit-filter: ", ";\n    "])), t.popupDropShadow, t.popupDropShadow);
  },
  shadowFallback: function shadowFallback(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      box-shadow: ", ";\n    "])), t.popupBoxShadow);
  },
  transitionEnter: function transitionEnter() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      opacity: 0.01;\n    "])));
  },
  'transition-enter-top': function transitionEnterTop() {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      transform: translateY(10px);\n    "])));
  },
  'transition-enter-bottom': function transitionEnterBottom() {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      transform: translateY(-10px);\n    "])));
  },
  'transition-enter-left': function transitionEnterLeft() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      transform: translateX(10px);\n    "])));
  },
  'transition-enter-right': function transitionEnterRight() {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      transform: translateX(-10px);\n    "])));
  },
  transitionEnterActive: function transitionEnterActive() {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      transition: transform 0.18s cubic-bezier(0.22, 0.61, 0.36, 1), opacity 0.18s cubic-bezier(0.22, 0.61, 0.36, 1);\n      opacity: 1;\n      transform: translate(0, 0);\n    "])));
  },
  transitionExit: function transitionExit() {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      opacity: 0.01;\n      transition: opacity 0.15s ease-out;\n      transform: translate(0, 0);\n    "])));
  }
});